/* global agenda:true */

/**
 * Agenda Object: This object creates and manipulates the DOM for agendas in the View.
 */
agenda = function (clientUrl, cui_enabled) {
	'use strict';
	var objAgenda = list(null, cui_enabled);
	var objDom = dom(cui_enabled);
	var objDialog = dialog();
	var objProposal = proposal(null, cui_enabled);
	var objList = list(null, cui_enabled);
	var objCustomRoute = customRoute();
	var saveCalls = [];

	var popitup = function(pageURL,w,h){
		var left = (($(window).width())/2)-(w/2);
		var top = (($(window).height())/2)-(h/2);
		var targetWin = window.open (pageURL, 'PrintAgenda', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
	};

	objAgenda.isCreateable = function(callback) {
		$.ajax({
			url: '/agenda/isCreateable.json',
			type: 'GET',
			success: function(result) {
				if (parseInt(result.isAdmin, 10) === 1) {
					if (callback) {
						callback();
					}
				} else if (parseInt(result.isAdmin, 10) === 0) {
					var dialog = objDialog.createBasicWarningDialog('not-an-agenda-admin-dialog', function(dialog, defaults) {
						$(dialog).html();
						$(dialog).append('You must be an agenda administrator to create a new agenda.');

						// Actions
						defaults.buttons = {
							'Ok': function() {
								$(this).dialog('close');
							}
						};
						// Cleanup
						defaults.close = function(event, ui) {
							$(this).remove();
						};
						$(dialog).dialog(defaults);
					});
				}
			}
		});
	};

	objAgenda.getFlyout = function(id, callback) {
		$.ajax({
			url: '/agenda:' + id + '/ajax/flyout',
			type: 'GET',
			data: {id: id, display:'flyout'},
			beforeSend: function() {
				objDom.addLoadingMask('#curriculog-summary-column');
			},
			success: function(result) {
				var summary = $(result).find('#summary-' + id);
				$('#summary-' + id).contents().remove();
				$('#summary-' + id).replaceWith(summary);
				$('#summary-' + id).addClass('active');
				objDom.removeMask('#curriculog-summary-column');
				objDom.verticalStretchList();
        callback && callback(id);
			}
		});
	};

	objAgenda.hideFlyout = function(){
		if($('.open-summary.active').length > 0) {
			$('.open-summary').removeClass('active');
			var detailClosed = $('#curriculog-list-column').outerWidth() - $('#curriculog-summary-column').outerWidth() - 1;
			if ( $('#curriculog-dashboard-column').hasClass('active') === false ){
				$('#curriculog-dashboard-column').addClass('active');
			}
			$('#curriculog-summary-column').animate({'left': detailClosed},
				function() {
					$('.summary.active').removeClass('active');
					$('#curriculog-summary-column').removeClass('active');
				}
			);
		}
	};

	objAgenda.refreshAgenda = function(id, status, callback){
		// Refresh both the proposal list and the agenda
		objDom.addLoadingMask('#curriculog-list-column-results');
		objAgenda.getAgenda(id, status);
		objAgenda.getProposalList(id, callback);
	};

	objAgenda.getAgenda = function(id, status) {
		$.ajax({
			url: '/agenda:' + id + '/ajax/agenda',
			data: {display: 'agenda'},
			type: 'GET',
			success: function(result) {
				// Clear the old data.
				$('#curriculog-fields-column-content').contents().remove();
				$('#curriculog-proposal-add').contents().remove();
				$('#curriculog-list-column-results-content').contents().remove();
				$('#curriculog-summary-column').contents().remove();
				$('#ineligible-proposals-removed').contents().remove();
				$('#curriculog-fields-column-toolbar').contents().remove();

				// Place in the new data.
				$(result).filter('#curriculog-fields-column-content').contents().appendTo($('#curriculog-fields-column-content'));
				$(result).filter('#curriculog-proposal-add').contents().appendTo($('#curriculog-proposal-add'));
				$(result).filter('#curriculog-list-column-results-content').contents().appendTo($('#curriculog-content #curriculog-list-column-results-content'));
				$(result).filter('#curriculog-summary-column').contents().appendTo($('#curriculog-content #curriculog-summary-column'));
				$(result).filter('#ineligible-proposals-removed').contents().appendTo($('#ineligible-proposals-removed'));
				$(result).filter('#curriculog-fields-column-toolbar').contents().appendTo($('#curriculog-fields-column-toolbar'));

				// Update the status.
				var content = $('#curriculog-content');
				var contentClass = content.attr('class').replace(/(status)-(\w*)/, '$1-' + status);
				content.attr('class', contentClass);

				// Resize with the new data.
				objAgenda.verticalStretchList();
				objList.changeItemVisibility();

				// Reinitialize the #agenda-notes rich-text field.
				objAgenda.initRichText();
				Curriculog.agendaForm.render();
				Curriculog.Actions.log('agenda-form-loaded');
			},
			complete: function () {
				objDom.removeMask('#curriculog-list-column-results');

				// reset the add/remove proposals button
				committees = objAgenda.getCommittees();
				if (committees.length === 0) {
					$('#curriculog-proposal-add').addClass('disabled');
				} else {
					$('#curriculog-proposal-add').removeClass('disabled');
				}
			}
		});

	};

	objAgenda.getProposalList = function(agendaId, callback) {
		$.ajax({
			url: '/agenda:' + $('#agendaId').val() + '/ajax/proposals',
			data: {display: 'proposalList'},
			type: 'GET',
			success: function(result) {
				objDom.removeMask('#curriculog-list-column-results');
				var listColumn = $('#curriculog-list-column-results-content');
				var summaryColumn = $('#curriculog-summary-column');


				// Clear the old data.
				listColumn.contents().remove();
				summaryColumn.contents().remove();


				// Place in the new data.
				$(result)
					.filter(listColumn.selector)
					.contents()
					.appendTo(listColumn);

				$(result)
					.filter(summaryColumn.selector)
					.contents()
					.appendTo(summaryColumn);

				// Resize with the new data.
				objAgenda.verticalStretchList();
				objList.changeItemVisibility();


				if (callback) {
					callback();
				}
			},
			complete: function () {
				// reset the add/remove proposals button
				committees = objAgenda.getCommittees();
				if (committees.length === 0) {
					$('#curriculog-proposal-add').addClass('disabled');
				} else {
					$('#curriculog-proposal-add').removeClass('disabled');
				}
				$(document).trigger('refreshAgenda');
			}
		});

	};

	objAgenda.validateAgenda = function() {
		$.validity.start();
		$('#agenda-name').require();
		var result = $.validity.end();
		return result.valid;
	};

	objAgenda.changeAgendaStatus = function(obj, status){
		objAgenda.hideFlyout();

		var dialog = '';

		function statusChange(status, obj) {
			if (status !== 'deleted') {
				$('input[name="agenda-status"]').val(status);
				objAgenda.saveAgenda();

			} else {
				var id = $(obj).attr('class').match(/(curriculog-)?agenda-(\d*)/)[2];
				var agenda = {
					id : id,
					status: 'deleted'
				};

				$.ajax({
					url: '/agenda:' + id + '.json',
					type: 'PUT',
					data: agenda,
					success: function(data) {
						objList.refreshList();
					}
				});
			}
		}

		var result, errorCount = 0;

		switch (status) {
		case 'publish':
			// first validate required fields
			$.validity.start();
			$('#agenda-form input').each(function (event) {
				$(this).require();
			});
			result = $.validity.end();

			var committees = [];
			// load in currently selected committees
			$('#agenda-committees .committee-item').each(function (index) {
				committees.push($(this).attr('id').match(/committee-(\d*)/)[1]);
			});

			if ($('#curriculog-list-column-results-content .open-summary').length === 0) {
				errorCount += 1;
				dialog = objDialog.createBasicWarningDialog('no-proposals', function (dialog, defaults) {
					// Message
					$(dialog).append('<br>You cannot launch an agenda without proposals. <br>Please add at least one proposal to this agenda.');
					// Actions
					defaults.buttons = {
						'Ok': function() {
							// STUFF
							$(this).dialog('close');
						}
					};
					// Cleanup
					defaults.close = function(event, ui) {
					// STUFF
						objDom.removeMask('#curriculog-list-column-results');
					};
					$(dialog).dialog(defaults);

				});
			}

			if (result.valid && errorCount === 0 && objAgenda.validateAgenda()) {
				dialog = objDialog.createDOMDialog('activate-agenda-dialog', function(dialog, defaults) {
					// Actions
					defaults.buttons = {
						'Publish Agenda': function() {
							$(dialog).dialog('close');
							statusChange('active', obj);
						},
						Cancel: function() {
							$(dialog).dialog('close');
						}
					};

					defaults.close = function(event, ui) {
						// STUFF
						objDom.removeMask('#curriculog-list-column-results');
					};

					$(dialog).dialog(defaults);
				});
			} else {
				objDom.removeMask('#curriculog-list-column-results');
			}
			break;
		case 'unpublish':
			dialog = objDialog.createDOMDialog('deactivate-agenda-dialog', function(dialog, defaults) {
				// Actions
				defaults.buttons = {
					'Unpublish Agenda': function() {
						$(dialog).dialog('close');
						statusChange('inactive', obj);
					},
					Cancel: function() {
						$(dialog).dialog('close');
					}
				};

				defaults.close = function(event, ui) {
					// STUFF
					objDom.removeMask('#curriculog-list-column-results');
				};

				$(dialog).dialog(defaults);
			});
			break;

		case 'delete':
			dialog = objDialog.createDOMDialog('delete-agenda-dialog', function(dialog, defaults) {
				// Actions
				defaults.buttons = {
					'Delete Agenda': function() {
						$(dialog).dialog('close');
						statusChange('deleted', obj);
					},
					Cancel: function() {
						$(dialog).dialog('close');
					}
				};
				$(dialog).dialog(defaults);
			});
			break;

		case 'complete':
			dialog = objDialog.createDOMDialog('complete-agenda-dialog', function(dialog, defaults) {
				// Actions
				defaults.buttons = {
					'Complete Agenda': function() {
						$(dialog).dialog('close');
						statusChange('completed', obj);
					},
					Cancel: function() {
						$(dialog).dialog('close');
					}
				};
				$(dialog).dialog(defaults);
			});
			break;

		case 'archive':
			if ($.inArray($('input[name="agenda-status"]').val(), ['active', 'inactive', 'completed']) !== -1 ) {
				statusChange('archived', obj);
			} else {
				// this request came from the list. give dialog
				dialog = objDialog.createDOMDialog('archive-agenda-dialog', function(dialog, defaults) {
					// Actions
					defaults.buttons = {
						'Archive Agenda': function() {
							$(dialog).dialog('close');
							statusChange('archived', obj);
						},
						Cancel: function() {
							$(dialog).dialog('close');
						}
					};
					$(dialog).dialog(defaults);
				});
			}
			break;
		}
	};

	objAgenda.removeCommittee = function(committeeObj) {
		var dialog = objDialog.createBasicWarningDialog('delete-committee', function(dialog, defaults) {
			// Message
			$(dialog).append('Are you sure you want to delete '+ $(committeeObj).text() +' from your agenda?');
			// Actions
			defaults.buttons = {
				'Delete Committee': function() {
					$(committeeObj).remove();
					objAgenda.saveAgenda();
					$(dialog).dialog('close');
				},
				Cancel: function() {
					$(this).dialog('close');
				}
			};
			$(dialog).dialog(defaults);

		});
	};

	objAgenda.getCommitteeProposals = function() {
		// get the proposals based on the committees
		var params = {
			sortBy: $('#dialog-sort-by').val()
		};

		$.ajax({
			url: '/agenda:' + $('#agendaId').val() + '/getProposalList.json',
			type: 'GET',
			data: params,
			beforeSend: function() {
				objDom.addLoadingMask('#proposals-available');
			},
			success: function(result) {
				$('#proposals-available').empty();
				if(result.data.length > 0) {

					$(result.data).each(function(index, item) {
						var crosslistings = item.crosslistedFamily;
						var active = (item.selected) ? ' active' : '';
						var crossIcon;
						var cleanName = DOMPurify.sanitize(item.name);
            if (cui_enabled) {
              crossIcon = (crosslistings) ? '<span class="screen-reader-text">Proposal has crosslistings.</span>' : '';
              var crossClass = (crosslistings) ? 'crosslisted' : '';
              $('#proposals-available').append('<li id="proposal-available-'+ item.id +'" class="proposal-step-'+ item.currentStepID +' select-field ' + active +' tip" title="' + crosslistings + '">' +
  						'<button class="curriculog-add-widget proposal value-'+ item.id +' ' + crossClass + '">'+ cleanName + crossIcon + '</button></li>');
            } else {
              crossIcon = (crosslistings) ? ' <img class="crosslisting-icon-dialog" src="/images/icons/flat/crosslist.png">' : '';
              $('#proposals-available').append('<li id="proposal-available-'+ item.id +'" class="proposal-step-'+ item.currentStepID +' select-field ' + active +' tip" title="' + crosslistings + '">' +
  						'<button class="curriculog-add-widget proposal value-'+ item.id +'">'+ cleanName + crossIcon + '</button></li>');
            }

					});
				} else {
					$('#proposals-available').append('<li class="no-proposals">There are no proposals available for this committee. If you believe this to be an error, please contact a system administrator.</li>');
				}
				objDom.removeMask('#proposals-available');
				Curriculog.Actions.log('proposals-picker-loaded');
			}
		});
	};


	// The Proposal Selector is used on the agenda page to allow users to pick the proposals to attach to their agenda
	objAgenda.openProposalSelector = function(committees, successCallback) {
		var dialog = objDialog.createDOMDialog('curriculog-proposal-selector-dialog', function(dialog, defaults) {

			// click event for choosing a proposal
			$('#proposals-available').on('click', '.proposal', function(event) {
				event.preventDefault();
				event.stopPropagation();
				$(this).closest('.select-field').toggleClass('active');
			});

			// sorting events for choosing proposals
			$('.dialog-sort-tools').on('change', '#dialog-sort-by', function(event) {
				event.preventDefault();
				objProposal.getCommitteeProposals();
			});

			// selecting multiple proposals
			// by X number
			$('.dialog-sort-tools').on('change', '#select-first', function(event) {
				event.preventDefault();
				$('#proposals-available li').removeClass('active');

				var x = 0;
				try {
					x = parseInt($(this).val(), 10);

					$('#proposals-available li').each(function(index, item) {
						if (index < x) {
							$(item).addClass('active');
						}
					});
				} catch (e) {
					console.error(e);
				}

			});

			// all proposals
			$('.dialog-sort-tools').on('click', '#select-all', function(event) {
				event.preventDefault();
				$('#proposals-available li').addClass('active');
			});

			// all proposals
			$('.dialog-sort-tools').on('click', '#select-none', function(event) {
				event.preventDefault();
				$('#proposals-available li').removeClass('active');
			});

			// get the relevant proposals (default sort of name)
			objAgenda.getCommitteeProposals();

			// Actions
			defaults.buttons = {
				'Done Selecting Proposals': function() {
					var proposals = [];
					$('#proposals-available li.active').each(function(index) {
						var proposal = {
							proposal: $(this).attr('id').match(/proposal-available-(\d*)/)[1],
							agenda: $('#agenda-form input[name="agenda-id"]').val(),
							decision: 'none',
							proposalStep: $(this).attr('class').match(/proposal-step-(\d*)/)[1],
							user: $('#agenda-form input[name="agenda-user"]').val()
						};
						proposals.push(proposal);
					});

					if (successCallback) {
						successCallback(proposals);
					}

					$(this).dialog('close');
				},
				Cancel: function() {
					$(this).dialog('close');
				}
			};

			defaults.close = function(event, ui) {
				// Clear out the selected items before the next use
				$('#proposals-available').off('click', '.proposal');
				$('.dialog-sort-tools').off('change', '#dialog-sort-by');
				$('.dialog-sort-tools').off('change', '#select-first');
				$('.dialog-sort-tools').off('click', '#select-all');
				// clear out old selected items
				$('#proposals-available li').removeClass('active');
				$('#proposals-available').empty();
			};

			$(dialog).dialog(defaults);
		});
	};

	objAgenda.manageAgendaProposals = function(proposals) {
		var data = {};
		data.proposals = JSON.stringify(proposals);
		data.display = 'proposalList';

		$.ajax({
			url: '/agenda:' + $('#agendaId').val() + '/ajax/proposals.json',
			type: 'PUT',
			data: data,
			beforeSend: function() {
				objDom.addLoadingMask('#curriculog-list-column-results');
			},
			success: function(result) {
				objAgenda.getAgenda($('#agendaId').val(), $('input[name="agenda-status"]').val());
			}
		});
	};


	objAgenda.getCommittees = function() {
		var committees = [];
		$('.committee-item:not(#committee-clone)').each(function(index,item) {
			var committee = parseInt($(this).attr('id').replace('committee-', ''), 10);
			committees.push(committee);
		});

		if (committees.length === 0) {
			$('#curriculog-proposal-add').addClass('disabled');
		} else {
			$('#curriculog-proposal-add').removeClass('disabled');
		}
		$(document).trigger('refreshCommittees');

		return committees;
	};

	objAgenda.initRichText = function() {
		var scopedItem = $('#agenda-notes');

		// Init rich-text with ckeditor
		$(scopedItem).ckeditor();

		$(scopedItem).each(function() {
			$(this).ckeditorGet().on('instanceReady', function(e) {
				objProposal.deactivateImageDrop(this);
				objAgenda.verticalStretchList();
			});

			$(this).ckeditorGet().on('resize', function(event) {
				objAgenda.verticalStretchList();
			});
		});
	};


	objAgenda.saveAgenda = function() {
		function save() {
			var committees = objAgenda.getCommittees();
			var agenda = {
				id : $('#agenda-form input[name="agenda-id"]').val(),
				name: $('#agenda-form input[name="agenda-name"]').val(),
				userID: $('#agenda-form input[name="agenda-user"]').val(),
				committees: committees,
				notes: $('#agenda-form textarea[name="agenda-notes"]').val(),
				status: $('#agenda-form input[name="agenda-status"]').val()
			};
			$.ajax({
				url: '/agenda:' + $('#agendaId').val() + '/form',
				type: 'PUT',
				contentType: 'application/json',
				data: JSON.stringify(agenda),
				beforeSend: function() {
					objDom.addMask('#curriculog-list-column-results');
				},
				success: function(data) {
					$('#curriculog-fields-column-agenda-name').text($('#agenda-form input[name="agenda-name"]').val());
					objAgenda.getAgenda($('#agendaId').val(), $('#agenda-form input[name="agenda-status"]').val());
				},
				error: function () {
					var publish = $('#curriculog-publish-widget');
					var unpublish = $('#curriculog-unpublish-widget');
					var action = '';
					if (publish.length === 0) {
						action = 'unpublish';
					} else {
						action = 'publish';
					}

					objDom.removeMask('#curriculog-list-column-results');
					var errorMsg = 'There was an error attempting to '+action+' this agenda.' +
									' The agenda was not '+action+'ed. Please try again. <br><br>' +
									'This problem has been reported.';
					$('#growls').notify('create', 'warning-template', {
						title: 'Warning',
						text: errorMsg
					},{
						expires: false
					});
				}
			});
		}

		objAgenda.hideFlyout();

		if ($('#agenda-form input[name="agenda-status"]').val() === 'inactive') {
			// check for ineligible proposals and save on callback
			objAgenda.ineligibleProposals(function() {
				save();
			}, 'save');

		} else {
			save();
		}
	};

	objAgenda.ineligibleProposals = function(callback, saveType, oldCommitteeElements) {
		// check committees to be sure we don't have to remove proposals
		var committees = objAgenda.getCommittees();

		$.ajax({
			url: '/agenda:' + $('#agendaId').val() + '/proposalConflicts.json',
			type: 'GET',
			data: {committees:JSON.stringify(committees)},
			beforeSend: function() {
				objDom.addMask('#curriculog-list-column-results');
			},
			complete: function() {
				objDom.removeMask('#curriculog-list-column-results');
			},
			error: function () {
				var errorMsg = 'There was an error checking for proposals to be removed from this agenda.' +
								' Your change was not saved. Please try your change again. <br><br>' +
								'This problem has been reported.';
				$('#growls').notify('create', 'warning-template', {
					title: 'Warning',
					text: errorMsg
				},{
					expires: false
				});

				if (typeof oldCommitteeElements !== 'undefined') {
					var committeesField = $('.curriculog-smartfield-dropzone');
					committeesField.children().remove('.committee-item');
					committeesField.append(oldCommitteeElements);

					// re-enable the add/remove proposals button if necessary
					if (oldCommitteeElements.length === 0) {
						$('#curriculog-proposal-add').addClass('disabled');
					} else {
						$('#curriculog-proposal-add').removeClass('disabled');
					}
				}

			},
			success: function(data) {
				if (data.proposals.removedProposals.length === 0) {
					// perform save
					if (callback) {
						callback();
					}

				} else {
					// Open dialog and allow cancel of change
					$('#ineligible-proposals-removed .warning-dialog-list').contents().remove();

					var dialog = objDialog.createDOMWarningDialog('ineligible-proposals-removed', function(dialog, defaults) {
						var total = 0;
						$(data.proposals.removedProposals).each(function(index, item) {
							var cleanName = DOMPurify.sanitize(item.name);
							if(index <= 4) {
								$('<li>' + cleanName + '</li>').appendTo($('#ineligible-proposals-removed .warning-dialog-list'));
							}
							total = index;
						});
						if(total > 4) {
							var more = total - 5;
							$('<li>and ' + more + ' more</li>').appendTo($('#ineligible-proposals-removed .warning-dialog-list'));
						}

						defaults.buttons = {
							'Continue with Change': function() {
								$(this).dialog('close');
								$.ajax({
									url: '/agenda:' + $('#agendaId').val() + '/proposalConflicts.json',
									type: 'GET',
									data: {deleteProposals: 1, committees:JSON.stringify(committees)},
									beforeSend: function() {
										this.proposalList = $('#curriculog-list-column-results-content');
										this.oldProposals = this.proposalList.children();
										objDom.addMask('#curriculog-list-column-results');
									},
									complete: function() {
										objAgenda.refreshAgenda($('#agendaId').val(), $('#agenda-form input[name="agenda-status"]').val(), function() {});
										objDom.removeMask('#curriculog-list-column-results');
									},
									success: function(data) {
										if (saveType !== undefined && saveType === 'save') {
											if (callback) {
												callback();
											}
										}
									},
									error: function() {
										var errorMsg = 'There was an error removing the proposals for this agenda.' +
														' Your change was not saved. Please try your change again. ' +
														'<br><br>This problem has been reported.';
										$('#growls').notify('create', 'warning-template', {
											title: 'Warning',
											text: errorMsg
										},{
											expires: false
										});

										// roll back the proposal list
										this.proposalList.children().remove();
										this.proposalList.append(this.oldProposals);
									}
								});
							},
							'Cancel Change': function() {
								objDom.addMask('#curriculog-list-column-results');
								objAgenda.refreshAgenda($('#agendaId').val(), $('#agenda-form input[name="agenda-status"]').val());
								$(this).dialog('close');
							}
						};
						defaults.close = function(event, ui) {
							$('#ineligible-proposals-removed .warning-dialog-list').contents().remove();
						};

						$(dialog).dialog(defaults);
					});
				}
			}
		});
	};

	objAgenda.checkProposalStatus = function() {
		// This function is used in two scenarios for unlaunched agendas only:
		// 1.) committee is changed, so some proposals may not be eligible for the new committee
		// 2.) proposal may have moved on while this agenda is unlaunched, so it will no longer be eligible for this agenda
		// first check if any proposals moved since this agenda was built
		if ( ($('input[name="agenda-status"]').val() === 'inactive') && ($('#advanced-proposals-removed .warning-dialog-list li').length > 0) ) {

			var dialog = objDialog.createDOMWarningDialog('advanced-proposals-removed', function(dialog, defaults) {

				// Actions
				defaults.buttons = {
					'Ok': function() {
						var committees = objAgenda.getCommittees();
						$.ajax({
							url: '/agenda:' + $('#agendaId').val() + '/proposalConflicts.json',
							type: 'GET',
							data: {deleteProposals: 1, committees:committees},
							beforeSend: function() {
								objDom.addMask('#curriculog-list-column-results');
							},
							success: function(data) {
								objDom.removeMask('#curriculog-list-column-results');
								$(dialog).dialog('close');
							}
						});
					}
				};
				defaults.close = function(event, ui) {
					objDom.removeMask('#curriculog-list-column-results');
					$('#advanced-proposals-removed .warning-dialog-list').contents().remove();
				};
				$(dialog).dialog(defaults);
			});
		}
	};

	objAgenda.makeDecision = function(obj, needsSignature, signatureType) {
		function signature(obj, decision, dialog) {
			var postParam = {
				id : $('#signature-dialog').find('input[name="user-id"]').val().trim(),
				pin : $('input#signature-pin').val().trim()
			};
			var xhr;
			// if user already signed once, use that pin for the rest of the items
			if (postParam.id.length > 0) {
				xhr = $.ajax({
					url: '/user/signature.json',
					type: 'get',
					data: postParam,
					success: function(result) {
						if (parseInt(result.success, 10) === 1) {
							// record the signature in the psa record
							//objProposal.changeStepAction = function(decision, sigDate, decisionFieldset, callback) {
							$.ajax({
								url: '/proposal:' + $(obj).closest('.open-summary').attr('id').replace('detail-','') + '/agendaSig.json',
								type: 'PUT',
								async: false,
								success: function(data) {
									objAgenda.forceDecision(obj, decision, '');
									$(dialog).dialog('close');
								}
							});

						} else {
							$('input#signature-pin').addClass('error');
							$('#signature-error').slideDown('medium');
						}
					}
				});
			}
			return xhr;
		}

		var decision = ($(obj).attr('class')).match(/action-((request-)?(\w*))/)[1];
		var dialog;
		var xhr;

		// If user has paper upload, warning message
		if ( (needsSignature) && (signatureType === 'paperSignatures') ) {

			dialog = objDialog.createBasicDialog('signature-paper-dialog', 'You must use electronic pin', function(dialog, defaults) {
				$(dialog).append('This proposal requires a signature for approval. The Quick Approve feature requires that you sign your ');
				$(dialog).append('documents using an Electronic Pin. Currently, your preferred signature method is File Upload. ');
				$(dialog).append('You must make this decision on the proposal. Do you want to go to the proposal now?');
				// Actions
				defaults.buttons = {
					'Go to proposal': function() {
						window.location = '/proposal:'+ $(obj).closest('.open-summary').attr('id').substring(7) + '/form?tab=decisions';
						$(this).dialog('close');
					},
					'Cancel': function() {
						$(this).dialog('close');
					}
				};
				$(dialog).dialog(defaults);
			});

		// Pin: check for already existing. If so, just approve. Otherwise, pop dialog
		} else if ( (needsSignature) && (signatureType === 'electronicPin') ) {

			if ($('#signature-pin').val() !== '') {
				xhr = signature(obj, decision, dialog);

			} else {
				dialog = objDialog.createDOMDialog('signature-dialog', function(dialog, defaults) {
					$(dialog).find('p#signature-custom-message').html('Please enter your signature pin to approve this proposal.');
					// Actions
					defaults.buttons = {
						'Sign': function() {
							// do ajax to see if pin was successfull
							var xhr = signature(obj, decision, dialog);
						},
						Cancel: function() {
							$('input#signature-pin').val('');
							$(this).dialog('close');
						}
					};
					defaults.close = function() {
						// if we are closing the pin dialog with cancel or esc because we
						// don't know our pin remove the error and reset the attempted value,
						// if any
						if ($('input#signature-pin').hasClass('error')) {
							$('input#signature-pin')
								.val('')
								.removeClass('error');
						}
						$('#signature-error').hide();
					};
					$(dialog).dialog(defaults);

				});
			}
		// No signature necessary. Just make the decision
		} else {
			// comment required for any decision OTHER than approve or
			switch(decision) {
			case 'approve':
				xhr = objAgenda.forceDecision(obj, decision, '');
				break;

			case 'reject':
				// launch comment dialog
				dialog = objDialog.createDOMDialog('comment-dialog', function(dialog, defaults) {
					$('#comment-fieldset').find('input[name="reply-to"]').attr('value', '');
					// Actions
					defaults.buttons = {
						'Add Comment': function() {
							$.validity.start();
							$('#comment').require();
							var result = $.validity.end();

							if (result.valid) {
								var xhr = objAgenda.forceDecision(obj, decision, $('#comment').val());
								$(this).dialog('close');
							}
						},
						Cancel: function() {
							$(this).dialog('close');
						}
					};
					$(dialog).dialog(defaults);
				});
				break;

			case 'request-route':
			case 'request-hold':
			case 'request-suspend':
			case 'request-cancel':
				dialog = objDialog.createBasicDialog('must-use-proposal', 'You must make this decision on the proposal', function(dialog, defaults) {
					$(dialog).append('This decision cannot be made on an agenda. You must make this decision on the proposal. Do you want to go to the proposal now?');
					// Actions
					defaults.buttons = {
						'Go to proposal': function() {
							window.location = '/proposal:'+ $(obj).closest('.open-summary').attr('id').substring(7) + '/form?tab=decisions';
							$(this).dialog('close');
						},
						'Cancel': function() {
							$(this).dialog('close');
						}
					};
					$(dialog).dialog(defaults);
				});
				break;
			}
		}

		return xhr;
	};


	objAgenda.forceDecision = function(obj, decision, userComment) {
		objAgenda.hideFlyout();
		var actionIds = [];
		var stepActions = $(obj).attr('class').match(/stepaction-[0-9\-]*/)[0];
		var actionArray = (stepActions.substring(11)).split('-');
		$(actionArray).each(function(index, item) {
			actionIds.push(parseInt(item, 10));
		});

		var agendaParams = {
			proposalID: $(obj).closest('.open-summary').attr('id').substring(7),
			userID: $('#agenda-form input[name="agenda-user"]').val(),
			decision: decision,
			currentStepID: $(obj).closest('.open-summary').attr('class').match(/step-(\d*)/)[1],
			agendaID : $('#agenda-form input[name="agenda-id"]').val(),
			proposalStepActionID : JSON.stringify(actionIds),
			addComment: 1,
			decisionComment: userComment
		};

		// submit the decision
		var xhr = $.ajax({
			url: '/agenda/decision.json',
			type: 'put',
			beforeSend: function() {
				objDom.addLoadingMask('#');
			},
			data: agendaParams,
			success: function(data){

				if (data.error) {
					var dialog = objDialog.createBasicWarningDialog('agenda-alreadyMoved-dialog', function(dialog, defaults) {
						$(dialog).append(data.msg);

						// Actions
						defaults.buttons = {
							'OK': function() {
								$(this).dialog('close');
							}
						};
						defaults.close = function() {
							$(this).remove();
						};
						$(dialog).dialog(defaults);
					});
				} else {
					// Ajax is necessary to not only reflect the decision made, but also whether the proposal has moved on
					$.ajax({
						url: '/agenda:'+ $('#agenda-form input[name="agenda-id"]').val() +'/status.json',
						type: 'get',
						beforeSend: function() {
							objDom.addLoadingMask('#');
						},
						success: function(result){
							if (result.status === 'completed') {
								var dialog = objDialog.createBasicDialog('agenda-complete-dialog', 'This Agenda is Complete', function(dialog, defaults) {
									$(dialog).append('You have no more proposals on this agenda. This agenda is now complete and ready for archiving. ');
									$(dialog).append('Would you like to archive this agenda now?');
									$(dialog).append('(Please note that some of the proposals on this agenda may be waiting for other decisions, and have not advanced in their approval process yet.)');

									// add in the archive icon
									$('#curriculog-fields-column-toolbar .toolbar-section.active button.action-unpublish').remove();
									var btn = '<button class="curriculog-agenda-action action-archive" id="curriculog-archive-widget" title="Archive Agenda"><img src="/images/icons/flat/archive.png" /></button>';
									$('#curriculog-fields-column-toolbar').children(':first').find('.toolbar-section').append(btn);

									// Actions
									defaults.buttons = {
										'Archive Now': function() {
											objAgenda.changeAgendaStatus(obj, 'archive');
											// $('#curriculog-fields-column-toolbar .toolbar-section.active button.action-unpublish').remove();
											$(this).dialog('close');
										},
										'Do Not Archive Yet': function() {
											objAgenda.refreshAgenda(agendaParams.agendaID, result.status);
											$(this).dialog('close');
										}
									};
									defaults.close = function() {
										// Remove any comment that may remain in the form
										$('#comment').val('');
									};
									$(dialog).dialog(defaults);
								});
							} else {
								$('#curriculog-fields-column-toolbar .toolbar-section').find('button.action-unpublish').remove();
								objAgenda.refreshAgenda(agendaParams.agendaID, result.status);
								// Remove any comment that may remain in the form
								$('#comment').val('');
							}
						}
					});
				}
			}
		});
		return xhr;
	};

	objAgenda.checkCustomRoute = function(callback) {
		// if the current step contains a committee with agenda, is trying to create a custom route,
		// and agendaId is empty, cannot continue. Warning dialog, force user to pick their agenda.
		if (($('#history .steps .step-current .participant-committee').length > 0) &&
			($('#agendaId').val() === '') ) {

			$.ajax({
				url: '/proposal:' + $('#proposalId').val() + '/stepAgendas.json',
				type: 'GET',
				success: function(result) {
					var dialog = objDialog.createDOMWarningDialog('missing-agenda-dialog', function(dialog, defaults) {
						$('#agendas-available').on('click', '.agenda', function(event) {
							event.preventDefault();
							event.stopPropagation();
							// only one item may be selected
							$('#agendas-available .select-field').removeClass('active');
							$(this).closest('.select-field').toggleClass('active');
						});

						// Load in the agendas on this step
						$(result.agendas).each(function(index, item) {
							var cleanName = DOMPurify.sanitize(item.name);
							$('#agendas-available').append('<li id="agenda-available-'+ item.id +'" class="select-field">' +
							'<button class="curriculog-add-widget agenda value-'+ item.id + '">'+ cleanName +'</button></li>');
						});
						defaults.buttons = {
							'Select Agenda': function() {
								$('#agendaId').val($('#agendas-available li.active').attr('id').match(/agenda-available-(\d*)/)[1]);

								if (callback) {
									callback();
								}

								$(this).dialog('close');
							},
							'Cancel': function() {
								$(this).dialog('close');
							},
						};

						defaults.close = function(event, ui) {
							// Clear out the selected items before the next use
							$('#agendas-available').off('click', '.agenda');
							// clear out old selected items
							$('#agendas-available li').removeClass('active');
						};

						$(dialog).dialog(defaults);
					});
				}
			});
		} else {
			if (callback) {
				callback();
			}
		}
	};

	objAgenda.missingAgenda = function(proposalId, obj, callback) {
		// If item does not have all of its agendas amassed, warning dialog (all agendas not needed, but it is good to warn the user)
		var committeeList = $('<ul class="warning-dialog-list"></ul>');
		$('#summary-' + proposalId + ' .step-current .participant-committee.no-agenda').each(function() {
			$(committeeList).append($('<li></li>').append($(this).text()));
		});

		var dialog = objDialog.createBasicWarningDialog('missing-agenda-dialog', function(dialog, defaults) {
			$(dialog).append('This proposal is missing an active agenda from the following committees:');
			$(dialog).append(committeeList);
			$(dialog).append('Once you make a decision on a proposal, these missing committees will not be able to <br>place this proposal on their agenda. ');
			$(dialog).append('Are you sure you want to continue?');

			// Actions
			defaults.buttons = {
				'Continue': function() {
					if (callback) {
						callback(obj);
					}

					$(this).dialog('close');
				},
				'Cancel': function() {
					$(this).dialog('close');
				}
			};
			$(dialog).dialog(defaults);
		});
	};

	objAgenda.printAgenda = function(obj) {
		popitup('/agenda:' + $(obj).attr('class').match(/agenda-(\d*)/)[1] + '/print?limit=0&printNow=1', '750', '500');
	};

	objAgenda.verticalStretchList = function() {
		objDom.verticalStretchList();
	};

	return objAgenda;
};
